import { InputTrimDirective } from '@/extensions/inputTrimDirective';
import { ReferralHelper } from '@/helpers/referral.helper';
import { AlertService } from '@/services/alert.service';
import { ReferralStateService } from '@/services/referral-state.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ErrorBusinessCode, ReferralCreate, ReferralService } from '@eemo/api-client';

@Component({
  selector: 'app-referral-add-dialog',
  templateUrl: './referral-add-dialog.component.html',
  styleUrls: ['./referral-add-dialog.component.scss'],
  imports: [
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    InputTrimDirective,
    MatButtonModule,
  ],
})
export class ReferralAddDialogComponent implements OnInit {
  private referralService = inject(ReferralService);
  private referralState = inject(ReferralStateService);
  private alertService = inject(AlertService);
  private fb = inject(UntypedFormBuilder);
  dialogRef = inject<MatDialogRef<ReferralAddDialogComponent>>(MatDialogRef);

  referralForm: UntypedFormGroup;
  formSubmitting = false;

  // convenience getter for easy access to form fields
  f(field: string): AbstractControl {
    return this.referralForm.get(field);
  }

  ngOnInit() {
    this.referralForm = this.fb.group({
      // lengths of the API contract
      name: ['', [Validators.required, Validators.maxLength(50)]],
      firstName: ['', [Validators.required, Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(255)]],
    });
  }

  onSubmit() {
    if (this.referralForm.invalid) {
      this.referralForm.markAllAsTouched();
      return;
    }
    this.formSubmitting = true;
    const referral: ReferralCreate = {
      name: this.f('name').value.trim(),
      firstName: this.f('firstName').value.trim(),
      email: this.f('email').value.trim(),
    };
    this.referralService.createReferral(referral).subscribe({
      next: () => {
        this.referralState.refresh();
        this.dialogRef.close(true);
        this.alertService.success(
          `${referral.firstName} ${referral.name} a été ajouté à vos filleuls. Un e-mail lui a été envoyé.`,
        );
      },
      error: (err: HttpErrorResponse) => {
        this.formSubmitting = false;
        if (err.error?.businessCode === ErrorBusinessCode.REFERRAL_EMAIL_NOT_ALLOWED) {
          this.f('email').setErrors({ notAllowed: true });
          return;
        }
        const message = ReferralHelper.businessErrorMessage(err);
        if (message) {
          // the eligibility or the pending referral count has changed: refresh the views
          this.referralState.refresh();
          this.alertService.error(message);
        }
        this.dialogRef.close(false);
      },
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
